import { FC } from 'react';
import { PaginationContextProvider } from 'utils/contexts/pagination';

import { AssetsQueryContextProvider } from '../../contexts/AssetsQueryContextProvider';
import { FilterContextProvider } from '../../contexts/FilterContextProvider';
import { SelectionContextProvider } from '../../contexts/SelectionContext';
import { TakeoverContextProvider } from '../../contexts/TakeoverProvider';
import { UploadAssetsContextProvider } from '../../contexts/UploadAssetsContextProvider';
import { ViewContextProvider } from '../../contexts/ViewContext';
import { IndexPage } from './IndexPage';
import { defaults } from '../../constants';
import { SortingContextProvider } from 'utils/contexts/sorting';
import { CreativeLibraryIndexErrorBoundary as ErrorBoundary } from './errorBoundary/CreativeLibraryIndexErrorBoundary';

export const IndexPageContextWrapper: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <ViewContextProvider>
      <PaginationContextProvider>
        <SortingContextProvider defaultSortField={defaults.sortBy}>
          <FilterContextProvider>
            <AssetsQueryContextProvider>
              <SelectionContextProvider>
                <TakeoverContextProvider>
                  <UploadAssetsContextProvider canEditBeforeUpload>
                    {children}
                  </UploadAssetsContextProvider>
                </TakeoverContextProvider>
              </SelectionContextProvider>
            </AssetsQueryContextProvider>
          </FilterContextProvider>
        </SortingContextProvider>
      </PaginationContextProvider>
    </ViewContextProvider>
  );
};

export const IndexPageContext = () => (
  <IndexPageContextWrapper>
    <ErrorBoundary>
      <IndexPage />
    </ErrorBoundary>
  </IndexPageContextWrapper>
);
